import React, {useEffect} from "react";
import {VisuallyHidden} from "@unibuddy/patron";

const SCREEN_READER_MESSAGE_DELAY = 150;

export function CTAActionsScreenReaderLabel() {
    useEffect(() => {
        const messageListener = (e: MessageEvent) => {
            if (e.data === "showCTAActionsAria=true") {
                setTimeout(() => {
                    // Get announcement area and set the text to the text we
                    // want to announce to the screen reader
                    const announcementArea = document.getElementById("announcement-area");
                    if (announcementArea) {
                        announcementArea.textContent =
                            "Unibuddy Assistant is here to help! Find us at the end of the page.";
                    }
                }, SCREEN_READER_MESSAGE_DELAY);
            }
        };

        window.addEventListener("message", messageListener, true);

        return () => {
            window.removeEventListener("message", messageListener);
        };
    }, []);

    return <VisuallyHidden role="status" id="announcement-area"></VisuallyHidden>;
}
